import { Step } from "../types/Step";
import { stepPath } from "../config/stepPath";

export const getPath = (step: Step, intermediario?: string): string => {
  const intermediarioPath = intermediario ? "/" + encodeURIComponent(intermediario) : "";
  return intermediarioPath + stepPath[step];
};
